/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
export const GET_PLATFORM_DEVICES = 'GET_PLATFORM_DEVICES';
export const GET_PLATFORM_DEVICES_FAILURE = 'GET_PLATFORM_DEVICES_FAILURE';
export const GET_PLATFORM_DEVICES_SUCCESS = 'GET_PLATFORM_DEVICES_SUCCESS';

export const GET_PLATFORM_DEVICE = 'GET_PLATFORM_DEVICE';
export const GET_PLATFORM_DEVICE_SUCCESS = 'GET_PLATFORM_DEVICE_SUCCESS';
export const GET_PLATFORM_DEVICE_FAILURE = 'GET_PLATFORM_DEVICE_FAILURE';

export const UPDATE_DEVICE_TABLE_SORT = 'UPDATE_DEVICE_TABLE_SORT';

export const MQTT_STATUS_CONNECTING = 'MQTT_STATUS_CONNECTING';
export const MQTT_STATUS_CONNECTED = 'MQTT_STATUS_CONNECTED';
export const MQTT_STATUS_SUBSCRIBING = 'MQTT_STATUS_SUBSCRIBING';
export const MQTT_STATUS_SUBSCRIBE_SUCCESS = 'MQTT_STATUS_SUBSCRIBE_SUCCESS';
export const MQTT_STATUS_SUBSCRIBE_FAILURE = 'MQTT_STATUS_SUBSCRIBE_FAILURE';
export const MQTT_MESSAGE = 'MQTT_MESSAGE';
export const MQTT_STATE_MESSAGE = 'MQTT_STATE_MESSAGE';
export const MQTT_STATUS_DISCONNECTING = 'MQTT_STATUS_DISCONNECTING';
export const MQTT_STATUS_DISCONNECTED = 'MQTT_STATUS_DISCONNECTED';

export const UPDATE_DEVICE_SHOW_DELETE_CONFIRM = 'UPDATE_DEVICE_SHOW_DELETE_CONFIRM';
export const DELETE_PLATFORM_DEVICES_SUCCESS = 'DELETE_PLATFORM_DEVICES_SUCCESS';
export const DELETE_PLATFORM_DEVICES_FAILURE = 'DELETE_PLATFORM_DEVICES_FAILURE';

export const DELETE_PLATFORM_DEVICE = 'DELETE_PLATFORM_DEVICE';
export const DELETE_PLATFORM_DEVICE_SUCCESS = 'DELETE_PLATFORM_DEVICE_SUCCESS';
export const DELETE_PLATFORM_DEVICE_FAILURE = 'DELETE_PLATFORM_DEVICE_FAILURE';

export const UPDATE_PLATFORM_DEVICE_SUCCESS = 'UPDATE_PLATFORM_DEVICE_SUCCESS';
export const UPDATE_PLATFORM_DEVICE_FAILURE = 'UPDATE_PLATFORM_DEVICE_FAILURE';

export const DEVICE_TABLE_SET_PAGE = 'DEVICE_TABLE_SET_PAGE';
export const DEVICE_TABLE_SELECT_ALL = 'DEVICE_TABLE_SELECT_ALL';
export const DEVICE_TABLE_CLEAR_SEARCH = 'DEVICE_TABLE_CLEAR_SEARCH';

export const GET_DEVICE_CONN_LOGS_SUCCESS = 'GET_DEVICE_CONN_LOGS_SUCCESS';
export const GET_DEVICE_CONN_LOGS_FAILURE = 'GET_DEVICE_CONN_LOGS_FAILURE';

export const UPDATE_DEVICE_DETAIL_SHOW_DELETE_CONFIRM = 'UPDATE_DEVICE_DETAIL_SHOW_DELETE_CONFIRM';
export const UPDATE_SHOW_RECENT_EVENT_MODAL = 'UPDATE_SHOW_RECENT_EVENT_MODAL';
export const UPDATE_SELECTED_EVENT = 'UPDATE_SELECTED_EVENT';

export const DEVICE_TABLE_CLEAR_REDIRECT = 'DEVICE_TABLE_CLEAR_REDIRECT';
